import { getEnv, Instance, types } from "mobx-state-tree";

export const CollapsibleServiceModel = types
  .model({
    collapsedContentKey: types.string,
    isCollapsed: types.optional(types.boolean, true),
  })
  .actions((self) => ({
    afterCreate() {
      const initialValue = getEnv(self).appSessionStorage.getStorageItem(self.collapsedContentKey);
      if (initialValue) {
        self.isCollapsed = JSON.parse(initialValue);
      }
    },

    toggle() {
      const collapsedContentState = getEnv(self).appSessionStorage.getStorageItem(
        self.collapsedContentKey
      );

      if (collapsedContentState) {
        const value = !JSON.parse(collapsedContentState);
        self.isCollapsed = value;
        getEnv(self).appSessionStorage.setStorageItem(self.collapsedContentKey, value.toString());
      } else {
        self.isCollapsed = !self.isCollapsed;
        getEnv(self).appSessionStorage.setStorageItem(
          self.collapsedContentKey,
          self.isCollapsed.toString()
        );
      }
    },
  }));

export type CollapsibleService = Instance<typeof CollapsibleServiceModel>;
